import React from 'react';
import {Redirect, Route, Switch, useLocation} from 'react-router-dom';
// @material-ui/core components
import {makeStyles} from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';

// core components
import AuthNavbar from 'components/Navbars/AuthNavbar.js';
import AuthHeader from 'components/Headers/AuthHeader.js';
import AuthFooter from 'components/Footers/AuthFooter.js';

import routes from 'routes/auth';

import componentStyles from 'assets/theme/layouts/auth.js';
import {useIntl} from 'react-intl';

const useStyles = makeStyles(componentStyles);

const Auth = () => {
  const intl = useIntl();
  const classes = useStyles();
  const mainContent = React.useRef(null);
  const location = useLocation();
  const brandText = intl.formatMessage({id:"navbar.brand_text"});

  React.useEffect(() => {
    document.body.classList.add(classes.bgDefault);
    document.title = brandText;
    return () => {
      document.body.classList.remove(classes.bgDefault);
    };
  });
  React.useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    mainContent.current.scrollTop = 0;
  }, [location]);

  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      return (
        <Route
          path={prop.path}
          component={prop.component}
          key={key}
          exact={prop.exact}
        />
      );
    });
  };

  return (
    <>
      <div className="main-content" ref={mainContent} id='main-content'>
        <AuthNavbar />
        <AuthHeader />
        {/* Page content */}
        <Container
          component={Box}
          maxWidth="xl"
          marginTop="-8rem"
          paddingBottom="3rem"
          position="relative"
          zIndex="101"
        >
          <Box component={Grid} container justifyContent="center">
            <Switch>
              {getRoutes(routes(intl))}
              <Redirect from="*" to="/login" />
            </Switch>
          </Box>
        </Container>
      </div>
      <AuthFooter />
    </>
  );
};

export default Auth;
